import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiAlertCircle, FiInfo, FiSettings, FiBarChart } from 'react-icons/fi';

const MobileOptimizedTabNavigation = ({ currentStep, setCurrentStep, partOneCompleted }) => {
  const tabs = [
    { 
      id: 1, 
      icon: FiInfo,
      title: 'Project Info',
      subtitle: 'Basic details',
      required: true 
    },
    { 
      id: 2, 
      icon: FiSettings,
      title: 'Requirements', 
      subtitle: 'Specifications',
      required: false 
    },
    { 
      id: 3, 
      icon: FiBarChart,
      title: 'Results', 
      subtitle: 'Sync & export',
      required: false 
    }
  ];

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-3 sticky top-16 z-30">
      <div className="flex justify-between gap-2">
        {tabs.map((tab, index) => (
          <motion.button
            key={tab.id}
            whileTap={{ scale: 0.95 }}
            className={`flex-1 relative p-3 rounded-xl transition-all ${
              currentStep === tab.id 
                ? 'bg-primary text-white shadow-lg' 
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
            onClick={() => setCurrentStep(tab.id)}
          >
            {/* Step indicator line */}
            {index < tabs.length - 1 && (
              <div className="absolute top-1/2 -right-1 w-2 h-0.5 bg-gray-200 transform -translate-y-1/2 z-0"></div>
            )}
            
            <div className="flex flex-col items-center gap-1 relative z-10">
              <div className={`flex items-center justify-center w-8 h-8 rounded-lg ${
                currentStep === tab.id ? 'bg-white/20' : 'bg-white'
              }`}>
                <SafeIcon 
                  icon={tab.icon} 
                  size={16} 
                  className={currentStep === tab.id ? 'text-white' : 'text-primary'} 
                />
              </div>
              <div className="text-center">
                <p className={`text-xs font-semibold leading-tight ${
                  currentStep === tab.id ? 'text-white' : 'text-gray-900'
                }`}>
                  {tab.title}
                </p>
                <p className={`text-xs leading-tight ${
                  currentStep === tab.id ? 'text-white/80' : 'text-gray-500'
                }`}>
                  {tab.subtitle}
                </p>
              </div>
            </div>

            {/* Status indicators */}
            <div className="absolute -top-1 -right-1">
              {tab.id === 1 && partOneCompleted && (
                <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiCheckCircle} className="text-white" size={12} />
                </div>
              )}
              {tab.id > 1 && !partOneCompleted && (
                <div className="w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiAlertCircle} className="text-white" size={12} />
                </div>
              )}
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default MobileOptimizedTabNavigation;